import {
    LOGOUT_USER,
    LOGIN_USER,
    USER_SET_CGU_VERSION,
    USER_SET_FIRST_SEEN_DATE,
    USER_SET_IS_SWITCHING_HCS,
    USER_SET_HAS_MANY_HCS,
} from '../constants/types'

const initialState = {
    role: null,
    currentUserCGUVersion: null,
    firstSeenDate: null,
    isSwitchingHcs: false,
    hasManyHcs: false,
}

const auth = (state = initialState, action: any) => {
    switch (action.type) {
        case LOGIN_USER:
            return {
                ...state,
                role: action.payload.role,
            }
        case LOGOUT_USER:
            return {
                ...initialState,
            }
        case USER_SET_CGU_VERSION:
            return {
                ...state,
                currentUserCGUVersion: action.payload.currentUserCGUVersion,
            }
        case USER_SET_FIRST_SEEN_DATE:
            return {
                ...state,
                firstSeenDate: action.payload.date,
            }
        case USER_SET_IS_SWITCHING_HCS:
            return {
                ...state,
                isSwitchingHcs: action.payload.isSwitchingHcs,
            }
        case USER_SET_HAS_MANY_HCS:
            return {
                ...state,
                hasManyHcs: action.payload.hasManyHcs,
            }
        default:
            return state
    }
}

export default auth
